export default function (col) {
  return typeof col.visible === 'undefined' || '' + col.visible === 'true'
}



// WEBPACK FOOTER //
// ./~/vue2-datatable-component/src/_utils/isColVisible.js